module.exports = __webpack_public_path__ + "img/album_1_m.25802c97.jpg";